<template>
  <div class="upload-files-wrap">
    <div class="upload-files row">
      <div class="images-wrap" v-if="displayImgs">
        <div class="img-item-wrap" :style="{width: (imgItemStyle.w)+'px',height: (imgItemStyle.h)+'px'}"  v-for="(item,index) in totalImgList" :key="index">
          <img class="img" :src="item.url" >
          <span class="clear" @click="delImg(index,item)">
            <i class="fa fa-close">X</i>
          </span>
        </div>
      </div>
      <div v-if="isShowFile" class="file" :style="{width: (imgItemStyle.w)+'px',height: (imgItemStyle.h)+'px'}"  @click="uploadPic">
        <span class="c" :style="{lineHeight:(imgItemStyle.h)+'px'}">+</span>
      </div>
      <input v-if="multiple" ref="getFiles" style="visibility:hidden" multiple="multiple" type="file"  @change="getFiles($event)" accpet = "image/*" capture >
      <input v-else ref="getFiles" style="visibility:hidden" type="file"  @change="getFiles($event)" accpet = "image/*" capture >
      <!--<span v-show="hasNotice" class="tip">提示：上传图片为正方形，像素800*800，图片大小在2M以下</span>-->
    </div>
  </div>
</template>
<script>
  import api from '../api/api'
  import util from '../utils/util'
  export default {
  props: {
    multiple:{
      type:Boolean,
      default:true
    },
    type:{
      type:String,
      default:''
    },
    hasNotice:{
      type:Boolean,
      default: true
    },
    leadImgList:{
      type:Array,
      default: function () {
        return []
      }
    },
    imgItemStyle:{
      type:Object,
      default:function () {
        return {
          w:'80',
          h:'80'
        }
      }
    },
    onlyOne:{
      type:Boolean,
      default:false
    },
    displayImgs:{
        type:Boolean,
        default:true
    }
  },
  data(){
    return{
      initImgList:[],
      uploadImgList:[],
      uploadImgInfo:{
        maxCount:5,
        maxSize:5
      },
    }
  },
  mounted(){
  },
  watch:{
    leadImgList(list){
      this.uploadImgList = []
      this.initImgList = util.deepClone(list)
    }
  },
  computed:{
    totalImgList(){
      // console.log('computed totalImgList----')
      console.log('uploadImgList ----',this.uploadImgList)
      console.log('initImgList ----',this.initImgList)
      return this.initImgList.concat(this.uploadImgList)
    },
    isShowFile(){
      if(this.totalImgList.length>=1 && this.onlyOne){
        return false
      }else{
        return true
      }
    }
  },
  methods: {
    clearAllImg(){
      this.initImgList = []
      this.uploadImgList = []
    },
    uploadPic() {
      console.log('uploadFile')
      this.$refs.getFiles.click()
    },
    //压缩图片
    compress :function(base64, bili, callback) {
      var that = this;
      var _img = new Image();
      _img.src = base64;
      _img.onload = function () {
        var _canvas = document.createElement("canvas");
        var w = this.width * bili;
        var h = this.height * bili;
        _canvas.setAttribute("width", w);
        _canvas.setAttribute("height", h);
        _canvas.getContext("2d").drawImage(this, 0, 0, w, h);
        var base64 = _canvas.toDataURL("image/jpeg");
        _canvas.toBlob(function (blob) {
          console.log(blob.size);
          if (blob.size > 1024 * 1024) {
            that.compress(base64, bili, callback);
          } else {
            callback(blob, base64);
          }
        }, "image/jpeg");
      }
    },
    getFiles:function (info) {
      var that = this;
      var typeFlag = true;
      var ext = '';
      var uploadImg = [];
      var i,j;
      var files = info.target.files;
      if(files.length==0){
        return
      }
      var currentCount = files.length;
      var nowImgCount = this.uploadImgList.length;
      var newCount = currentCount+nowImgCount;
      for(i = 0 ; i < files.length ; i++){
        var fileName = files[i].name;
        if (!/\.(jpg|png|jpeg|gif|JPG|PNG|JPEG|GIF)$/.test(fileName)) {
          ext = fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
          typeFlag = false;
        }
      }
      if(newCount > this.uploadImgInfo.maxCount){
        this.$Message.error('图片最多选择'+this.uploadImgInfo.maxCount+'张')
        return
      }
      if(!typeFlag){
        var failMsg = '不支持上传' + ext + '格式的文件，请检查文件格式是否为： jpg, jpeg, gif, png'
        this.$Message.error(failMsg)
        return
      }
      for(j = 0;j < files.length;j++){
        that.getPic(files[j],function (base64File) {
          that.compress(base64File,0.8,function (blob,newFile) {
            console.log('blob:----',blob)
            uploadImg.push(newFile)
            console.log('当前已上传照片数量：',uploadImg.length)
            if(files.length == uploadImg.length){
              that.uploadImg(uploadImg);
            }
          })
        })
      }
    },
    //转base64
    getPic:function(file,cb){
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        let base64Img = this.result
        if(cb){
          cb(base64Img)
        }
      };
    },
    //上传照片
    uploadImg:function (imgList) {
      var imgs = [];
      var that = this;
      var ids = [];
      imgList.forEach(function (img) {
        imgs.push({
          data : img,
          suf : 'jpg'
        })
      })
      var data = {
        files:imgs,
        type:this.type
      }
      api.uploadImgBase64(data).then(res => {
        res.forEach(function (item) {
          that.uploadImgList.push({
            url:item.location,
            id:item.id
          })
          ids.push(item.id)
        })
        //更新此次添加的列表
        that.$emit('checkFilesId',{
          type:'add',
          ids: that.uploadImgList
        })
        //所有列表更新
        that.$emit('updateTotalImgList', that.totalImgList)
        // console.log('组件内增加ids-----',ids)
        //注意 增加是数组形式
      }).catch(error => {
        this.$Message.error(error.message)
      })
    },
    checkDelImg(id){
      var flag = false;
      if(this.initImgList.length){
        this.initImgList.forEach(function (item,index,arr) {
          if(item.id == id){
            arr.splice(index,1)
            flag = true
          }
        })
      }
      if(!flag && this.uploadImgList.length){
        this.uploadImgList.forEach(function (item,index,arr) {
          if(item.id == id){
            arr.splice(index,1)
          }
        })
      }
    },
    /*删除*/
    delImg: function(index,item){
      this.checkDelImg(item.id);
      // this.totalImgList.splice(index,1)
      this.$emit('checkFilesId',{
        type:'del',
        ids: this.uploadImgList
      })
      //更新所有列表
      this.$emit('updateTotalImgList', this.totalImgList)
    }
  }
}
</script>
<style scoped lang="scss">
  .upload-files{
    /*display:flex;*/
    /*justify-content: flex-start;*/
    overflow: hidden;
    .file{
      float:left;
      position: relative;
      background-color: #fff;
      color: #B9B9B9;
      width: 70px;
      height: 70px;
      border: dashed 2px gainsboro;
      text-align: center;
      .c{
        font-size: 40px;
      }
      input{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        opacity: 0;
      }
    }
    .tip{
      font-size: 12px;
      color: #B9B9B9;
    }
    .images-wrap{
      /*&.row{*/
      /*justify-content: flex-start;*/
      /*flex-wrap: inherit;*/
      /*}*/
      overflow: hidden;
      float:left;
      .img-item-wrap{
        float: left;
        position: relative;
        margin-right: 8px;
        .img{
          width: 100%;
          height: 100%;
        }
        .clear{
          height: 34px;
          position: absolute;
          right: 2px;
          font-weight: 600;
          top: -15px;
          font-size: 12px;
          padding: 5px;
          cursor: pointer;
        }
      }
    }
  }
</style>
